import {
  EarlyChipSettingType,
  LevelLimitChip,
  MoneyInChip,
  ReBuyInType,
  StructuresResponse,
  TournamentDiscount,
  TournamentType,
} from "../pages/tournament/hook/useEditTournament";
import instance from "../utils/network";
import { YoutubeLiveRequest } from "./youtube-live";

export interface TimerDto {
  id: number;
  updatedAt: Date;
  now?: Date;
  playTime: number;
  isStop: boolean;
}
export interface TournamentResponse {
  id: number;
  createdAt: string;
  updatedAt: string;
  cafeId: number;
  title: string;
  subTitle: string;
  tournamentType: TournamentType;
  startDate: string;
  freeRoll: boolean;
  entry?: number;
  buyIn?: number;
  addOn?: number;
  reBuyIn?: number;
  buyInChip: number;
  reBuyInType: ReBuyInType;
  reBuyInCount: number;
  reBuyInChip: number;
  adOnCount: number;
  adOnChip: number;
  registerDeadlineLevel: number;
  earlyChipSetting: EarlyChipSettingType;
  userLimit?: number;
  earlyInChip?: number;
  levelLimitChip: LevelLimitChip[];
  prize: number;
  prizeGiveType: string;
  prizeType: string;
  moneyInChip: MoneyInChip[];
  registerLimitDate: string;
  structure: StructuresResponse[];
  reBuyInUserCount: number;
  entryUserCount: number;
  adOnUserCount: number;
  userCount: number;
  timer: string;
  isEnd: boolean;
  timerDto?: TimerDto;
  earlyInChipCount?: number;
  isAdditional: boolean;
  additional: number;
  additionalList: string;
  isFreezeOut: boolean;
  prizeWay?: string;
  notice?: string;
  useSolution: boolean;
  isDiscountExcluded: boolean;
  seed: number;
  totalDiscount: number;
  reservationCount: number;
  totalStack: number;
  tournamentDiscounts: TournamentDiscount[];
  prizeWait?: number;
}

export interface TournamentRequest {
  cafeId: number;
  title: string;
  subTitle: string;
  tournamentType: TournamentType;
  startDate: string;
  freeRoll: boolean;
  entry?: number | null;
  buyIn?: number | null;
  buyInChip: number;
  reBuyInType: ReBuyInType;
  reBuyInCount: number;
  reBuyInChip: number;
  adOnCount: number;
  adOnChip: number;
  registerDeadlineLevel: number;
  earlyChipSetting: EarlyChipSettingType;
  userLimit?: number | null;
  earlyInChip?: number | null;
  levelLimitChip?: LevelLimitChip[] | null;
  prize: number;
  prizeType: string;
  moneyInChip: MoneyInChip[];
  registerLimitDate: string;
  structure: StructuresResponse[];
  useSolution: boolean;
  isDiscountExcluded: boolean;
  prizeGiveType: string;
  addOn: number;
  isAdditional: boolean;
  isFreezeOut: boolean;
  additional: number;
  additionalList: string;
  youtubeLiveList?: YoutubeLiveRequest[];
  tournamentDiscounts?: TournamentDiscount[];
  reBuyIn: number;
  prizeWay: string;
  isReservation?: boolean;
}

export interface TournamentNoticeRequest {
  notice: string;
}

export interface TournamentPageResponse {
  total: number;
  tournaments: TournamentResponse[];
}

export interface TournamentPrizeListResponse {
  prizeList: MoneyInChip[];
  additionalList: string;
  tournamentType: TournamentType;
}

export function getStructuresByCafeId(
  cafeId: number,
  page: number,
  limit: number,
  type: string,
  filter: string,
): Promise<TournamentPageResponse> {
  return instance.get(`/seller/tournament/pub/${cafeId}`, {
    params: { page, limit, type, filter },
  });
}
export function updateTournamentNotice(
  id: number,
  request: TournamentNoticeRequest,
): Promise<{ code: number; message: any }> {
  return instance.put(`/seller/tournament/notice/${id}`, request);
}
export function getStructuresById(
  id: number,
  uuid?: string,
  width?: number,
  height?: number,
): Promise<TournamentResponse> {
  return instance.get(
    `/seller/tournament/detail/${id}?timer-id=${uuid}&width=${width}&height=${height}`,
  );
}

export function getTournamentNotEndByCafeId(
  cafeId: number,
): Promise<TournamentResponse[]> {
  return instance.get(
    `${
      process.env.REACT_APP_ENV === "stage" ? "/nest" : ""
    }/tournament/pub-not-end/${cafeId}`,
  );
}
export function getTournamentDetail(id: number): Promise<TournamentResponse> {
  return instance.get(`/seller/tournament/detail/${id}`);
}

export function getTournamentMoneyInList(
  tournamentId: number,
): Promise<TournamentPrizeListResponse> {
  return instance.get(`/seller/tournament/money-in/${tournamentId}`);
}

export function getTournamentNotReservationByCafeId(
  id: number,
): Promise<TournamentResponse[]> {
  return instance.get(`/seller/tournament/pub-not-reservation/${id}`);
}

export function registerTournament(
  pubId: number,
  request: FormData,
): Promise<{ code: number; message: any }> {
  return instance.post(`/seller/tournament/${pubId}`, request);
}

export function updateTournament(
  id: number,
  request: TournamentRequest,
): Promise<{ code: number; message: any }> {
  return instance.put(`/seller/tournament/${id}`, request);
}

export function removeTournament(
  id: number,
): Promise<{ code: number; message: any }> {
  return instance.delete(`/seller/tournament/${id}`);
}

export function memberSitOut(
  id: number,
  isSitOut: boolean,
  tournamentId: number,
): Promise<{ code: number; message: any }> {
  return instance.put(
    `/seller/tournament/sit-out/member/${id}?isSitOut=${isSitOut}&tournamentId=${tournamentId}`,
  );
}

export function userSitOutAll(
  tournamentId: number,
): Promise<{ code: number; message: any }> {
  return instance.put(`/seller/tournament/sit-out/all/${tournamentId}`);
}
